import { State } from "common/types/redux";

import { isSignedIn } from "seneca-common/features/user/state";

import {
  getClassEnrollment,
  getFetchChildClassEnrollmentsAreFetching,
  getFetchChildClassEnrollmentsSucceeded,
  getFetchClassEnrollmentsStarted,
  getFetchClassEnrollmentsSuccess,
  getFetchClassEnrollmentStarted
} from "../state";

export const classEnrollmentsNeedFetching = (state: State): boolean =>
  isSignedIn(state) &&
  !(
    getFetchClassEnrollmentsSuccess(state) ||
    getFetchClassEnrollmentsStarted(state)
  );

export const classEnrollmentNeedsFetching = (
  state: State,
  classId: string
): boolean =>
  isSignedIn(state) &&
  !getClassEnrollment(state, classId) &&
  !getFetchClassEnrollmentStarted(state, classId);

export const childClassEnrollmentsNeedsFetching = (
  state: State,
  userId: string
): boolean =>
  isSignedIn(state) &&
  !(
    getFetchChildClassEnrollmentsSucceeded(state, userId) ||
    getFetchChildClassEnrollmentsAreFetching(state, userId)
  );
